import { render, staticRenderFns } from "./bread_crumb.vue?vue&type=template&id=f5acb6e4&scoped=true&"
import script from "./bread_crumb.vue?vue&type=script&lang=js&"
export * from "./bread_crumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5acb6e4",
  null
  
)

export default component.exports